import { FormFieldType } from "@/components/ui/form-field/types";
import { z } from "zod";
import { ModalStateType } from "../../types";
import { AuthRegistrationResource } from "@/api/generated-api";

export const REGISTER_FORM_SCHEMA = z
  .object({
    email: z.string().trim().min(1, "Укажите e-mail").email("Введите корректный e-mail"),
    password: z
      .string()
      .min(8, "Пароль должен содержать минимум 8 символов")
      .regex(/^(?=.*\p{Ll})(?=.*\p{Lu}).+$/u, "Пароль должен содержать минимум одну строчную и одну заглавную букву."),
    password_confirmation: z.string().min(1, "Повторите пароль"),
  })
  .refine(data => data.password === data.password_confirmation, {
    message: "Пароли должны совпадать",
    path: ["password_confirmation"],
  });

export const REGISTER_FORM_FIELDS: Array<FormFieldType & { id: keyof AuthRegistrationResource }> = [
  {
    id: "email",
    label: "E-mail",
    type: "email",
    required: true,
    autoComplete: "off",
  },
  {
    id: "password",
    label: "Пароль",
    type: "password",
    required: true,
    autoComplete: "new-password",
  },
  {
    id: "password_confirmation",
    label: "Повторите пароль",
    type: "password",
    required: true,
    autoComplete: "new-password",
  },
];

export type ProcessingState = Exclude<ModalStateType, "login">;

export const SUCCESS_TEXT_MAP: Record<
  Exclude<ModalStateType, "login">,
  {
    title: string;
    subtitle: (email: string) => string;
    hint: string;
  }
> = {
  register: {
    title: "Почти готово! Подтвердите регистрацию",
    subtitle: (email: string) =>
      `Мы отправили письмо на <span>${email}</span>. Перейдите по ссылке в письме, чтобы завершить регистрацию.`,
    hint: "Если письмо не пришло в течение нескольких минут, проверьте папку «Спам».",
  },
  reset_password: {
    title: "Письмо для сброса пароля отправлено",
    subtitle: (email: string) =>
      `Мы отправили ссылку на <span>${email}</span>. Перейдите по ней, чтобы завершить смену пароля.`,
    hint: "Если письмо не пришло, проверьте папку «Спам» или повторите попытку.",
  },
};

export const ERROR_TEXT = {
  title: "Не удалось отправить письмо",
  subtitle: "Проверьте корректность e-mail и попробуйте снова.",
};

const USER_ALREADY_REGISTERED_ERROR_TEXT = {
  title: "Пользователь уже зарегистрирован",
  subtitle: "Пользователь с таким e-mail уже зарегистрирован. Попробуйте войти.",
};

export const getRegistrationErrorText = (status?: number) => {
  switch (status) {
    case 409:
      return USER_ALREADY_REGISTERED_ERROR_TEXT;
    default:
      return ERROR_TEXT;
  }
};

export const ERROR_BUTTON_TEXT_MAP: Record<ProcessingState, string> = {
  register: "Вернуться к регистрации",
  reset_password: "Вернуться к восстановлению пароля",
};
